import { MediaList } from '.';

export const mediaListMock: MediaList = {
  extraMedia: [],
  mainMedia: {
    file: '',
    mediaType: '',
  },
};
